export function convertDubaiToUTC(dubaiTimeString) {
    if (!dubaiTimeString) return dubaiTimeString;
    let s = String(dubaiTimeString).trim();
    if (s.endsWith('Z')) return s;
    if (/[+-]\d{2}:\d{2}$/.test(s)) return new Date(s).toISOString();

    // If it has no timezone indicator, input is Dubai local time (+04:00)
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        s = s + 'T00:00:00+04:00';
    } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(s)) {
        s = s + '+04:00';
    }
    const dubaiDate = new Date(s);
    return !isNaN(dubaiDate.getTime()) ? dubaiDate.toISOString() : dubaiTimeString;
}

